import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { cleanName, orNull } from '../../../common/utils/text';
import { useCreateTemplate } from '../contexts/notifications';
import { DEFAULT_CHANNEL } from '../utils/format';
import { validateTemplate } from '../utils/validate';
import TemplateFields from './fields';

import '../../../common/styles/catalog.css';

const EMPTY = { code: '', name: '', channel: DEFAULT_CHANNEL, trigger: '', provider_sid: '', parameters: [] };

export default function CreateTemplateForm() {
    const navigate = useNavigate();
    const { mutateAsync, isPending } = useCreateTemplate();

    const [form, setForm] = useState(EMPTY);
    const [localErrors, setLocalErrors]   = useState({});
    const [serverFields, setServerFields] = useState({});

    const setField = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
        if (localErrors[field] || serverFields[field]) {
            setLocalErrors(prev => ({ ...prev, [field]: undefined }));
            setServerFields(prev => ({ ...prev, [field]: undefined }));
        }
    };
    const fieldError = (field) => localErrors[field] || serverFields[field];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateTemplate(form);
        if (Object.keys(errors).length) { setLocalErrors(errors); return; }
        setLocalErrors({});
        setServerFields({});

        try {
            // Sin `status`: lo asigna el backend por defecto (el contrato solo documenta
            // status=0 para archivar, no el entero "activo").
            await mutateAsync({
                code:         form.code.trim().toUpperCase(),
                name:         cleanName(form.name),
                channel:      form.channel,
                trigger:      orNull(form.trigger),
                provider_sid: orNull(form.provider_sid),
                parameters:   form.parameters,
            });
            toast.success('Plantilla creada');
            navigate('/admin/notifications');
        } catch (err) {
            if (err?.status === 409) { setServerFields({ code: 'Ya existe una plantilla con ese código.' }); toast.error('Código en uso'); }
            else if (err?.fields) { setServerFields(err.fields); toast.error('Revisá los campos marcados'); }
            else toast.error(err?.message || 'No se pudo crear la plantilla');
        }
    };

    return (
        <form className="cat-form" onSubmit={handleSubmit}>
            <header className="cat-form__header">
                <Link to="/admin/notifications" className="cat-form__back">Notificaciones</Link>
                <h1 className="cat-form__title">Nueva plantilla</h1>
            </header>

            <TemplateFields form={form} setField={setField} fieldError={fieldError} disabled={isPending} />

            <footer className="cat-form__footer">
                <Link to="/admin/notifications" className="cat-form__cancel">Cancelar</Link>
                <button type="submit" className="cat-form__submit" disabled={isPending || !form.code.trim() || !form.name.trim()}>
                    {isPending ? 'Creando…' : 'Crear plantilla'}
                </button>
            </footer>
        </form>
    );
}
